import React from "react";
import AuthenticatedLayout from "../../layout/AuthenticatedLayout";
import emojiSucess from "../../images/emoji-sucess.png";
import { useNavigate } from "react-router-dom";
import "./CreatedFeedback.scss";
import { t } from "i18next";

const CreatedFeedback = (): React.JSX.Element => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(`/feedbacks`);
  }

  return (
    <AuthenticatedLayout>
      <div className="page-created d-flex flex-column justify-content-center align-items-center gap-5 flex-grow-1">
        <img src={emojiSucess} alt="Emoji sucess"/>
        <div className="text-sucess">
          <p className="fs-5 fw-bold">
            {t("createdFeedback.body")}
          </p>
          <span className="text-muted">{t("createdFeedback.wait")}</span>
        </div>
        <button className="btn btn-primary" onClick={handleClose}>{t("createdFeedback.close")}</button>
      </div>
    </AuthenticatedLayout>
  );
};

export default CreatedFeedback
